import React from 'react';
import { Container, Icons, IconWrapper, Img, Title, Wrapper } from './style';
import Image from '../../assets/imgs/blogPost.png';
import { data, tags, description } from '../../mock/blogPostData';
const BlogPost = () => {
    return (
        <Container>
            <Wrapper main>
                <Img src={Image} />
                <Wrapper titleWrapper>
                    {data.map((value) => {
                        return (
                            <Wrapper titleDesc key={value.id}>
                                <Wrapper wrap>
                                    <Title category>Date:</Title>
                                    {value.date}
                                </Wrapper>
                                <Wrapper wrap>
                                    <Title category>Category:</Title>
                                    {value.category}
                                </Wrapper>
                                <Wrapper wrap>
                                    <Title category>Author:</Title>
                                    {value.author}
                                </Wrapper>
                            </Wrapper>
                        )
                    })}
                    {data.map((value) => {
                        return (
                            <Title key={value.id} mainTitle>{value.title}</Title>
                        )
                    })}
                </Wrapper>
            </Wrapper>
            <Wrapper description>
                <Wrapper tags>
                    <Title titleTag>Tags</Title>
                    <Wrapper links  >
                        {tags.map((value) => {
                            return (
                                <Title key={value.id} tags>{value.tag}</Title>
                            )
                        })}
                    </Wrapper>
                    <Wrapper blog>
                        <Icons.Back />
                        <Title blogs>Back to Blog</Title>
                    </Wrapper>
                </Wrapper>

                <Wrapper desc>
                    {description.map((value) => {
                        return (
                            <Title mainDesc>{value.main} </Title>
                        )
                    })}
                    <Title descTitle>Morning Ritual // 9:00 AM</Title>
                    {description.map((value) => {
                        return (
                            <Title mainDesc>{value.morning}</Title>
                        )
                    })}
                    <Title descTitle>Mid-day Boost // 2:00 PM</Title>
                    {description.map((value) => {
                        return (
                            <Title mainDesc >{value.midDay}</Title>
                        )
                    })}
                    {description.map((value) => {
                        return (
                            <Title mainDesc2 >{value.midDay2}</Title>
                        )
                    })}
                    <Title descTitle>Evening Calm // 8:00 PM</Title>
                    {description.map((value) => {
                        return (
                            <Title mainDesc >{value.evening}</Title>
                        )
                    })}

                    <Wrapper IconWrapper>
                        <Title iconDesc >Share </Title>
                        <Wrapper icons>
                            <Icons.Facebook />
                            <Title iconTitle>Facebook</Title>
                        </Wrapper>
                        <Wrapper icons>
                            <Icons.Pinterest />
                            <Title iconTitle>Pinterest</Title>
                        </Wrapper>
                        <Wrapper icons>
                            <Icons.Twitter />
                            <Title iconTitle>Twitter</Title>
                        </Wrapper>
                        <Wrapper icons>
                            <Icons.Linkedln />
                            <Title iconTitle>Linkedln</Title>
                        </Wrapper>
                    </Wrapper>
                </Wrapper>

            </Wrapper>
        </Container>
    )
}

export default BlogPost;